const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Normalization rules from Freestar's Hashed Email Passthrough doc: trim, lowercase, and for
// gmail.com strip dots and any "+suffix" from the local part so every alias hashes to one value.
export function normalizeEmail(email: string): string | null {
  const trimmed = email.trim().toLowerCase();
  if (!EMAIL_PATTERN.test(trimmed)) return null;

  const [local, domain] = trimmed.split("@");
  if (domain !== "gmail.com") return trimmed;

  return `${local.split("+")[0].replace(/\./g, "")}@${domain}`;
}

export async function sha256Hex(value: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(value));
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
}
